import { render } from "./BtnAppStore.vue?vue&type=template&id=6bbc8d06"
import script from "./BtnAppStore.vue?vue&type=script&lang=js"
export * from "./BtnAppStore.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__